import { useState } from "react";
import { Paper, Typography, Box, TextField, Button, Grid } from "@mui/material";
import toast from "react-hot-toast";
import CandidateTransferService from "../../services/candidateTransfer.service";

const Actions = () => {
    const [candidateId, setCandidateId] = useState("");
    const [jobPostId, setJobPostId] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!candidateId || !jobPostId) {
            toast.error("Candidate ID and Job Post ID are required.");
            return;
        }

        try {
            setLoading(true);
            const res = await CandidateTransferService.regenerateCulturalFit({
                candidateId,
                jobPostId
            });
            if (res.data?.status) {
                toast.success(res.data?.message || "Successfully regenerated cultural fit.");
                setCandidateId("");
                setJobPostId("");
            } else {
                toast.error(res.data?.message || "Failed to regenerate cultural fit.");
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Paper elevation={0} sx={{ p: 3 }}>
            <Grid container spacing={2} sx={{ mt: 0 }}>
                <Grid item xs={12} sm={6} lg={3}>
                    <Paper elevation={0} sx={{ p: 3, borderRadius: 2, border: "1px solid #e0e0e0" }}>
                        <Box component="form" onSubmit={handleSubmit}>
                            <Typography variant="subtitle1" gutterBottom>
                                Regenerate Cultural Fit Report
                            </Typography>
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Candidate ID"
                                value={candidateId}
                                onChange={(e) => setCandidateId(e.target.value)}
                                required
                            />
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Job Post ID"
                                value={jobPostId}
                                onChange={(e) => setJobPostId(e.target.value)}
                                required
                            />
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                sx={{ mt: 2 }}
                                disabled={loading}
                            >
                                {loading ? "Regenerating..." : "Regenerate"}
                            </Button>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                    <Paper elevation={0} sx={{ p: 3, borderRadius: 2, border: "1px solid #e0e0e0" }}>
                        <Box component="form" onSubmit={handleSubmit}>
                            <Typography variant="subtitle1" gutterBottom>
                                Regenerate ...
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default Actions;
